module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-calendar dashboard-section--card"
  }, [_c('div', {
    staticClass: "board-calendar__header"
  }, [_c('h1', {
    staticClass: "dashboard-title"
  }, [_vm._v("Agenda")]), _vm._v(" "), _c('div', {
    staticClass: "board-calendar__nav"
  }, [_c('button', {
    staticClass: "board-calendar__nav-btn",
    attrs: {
      "title": "Jour précédent"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(-1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.5 15L7.5 10L12.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "board-calendar__date-label",
    class: {
      'board-calendar__date-label--today': _vm.isToday
    },
    attrs: {
      "title": _vm.isToday ? '' : 'Revenir à aujourd\'hui'
    },
    on: {
      "click": _vm.goToToday
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.formattedDate) + "\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "board-calendar__nav-btn",
    attrs: {
      "title": "Jour suivant"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])]), _vm._v(" "), _c('div', {
    ref: "eventsContainer",
    staticClass: "board-calendar__events dashboard-scroll dashboard-scroll--draggable",
    on: {
      "mousedown": _vm.handleMouseDown,
      "mouseleave": _vm.handleMouseLeave,
      "mouseup": _vm.handleMouseUp,
      "mousemove": _vm.handleMouseMove
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "board-calendar__loader"
  }, [_c('span', {
    staticClass: "board-calendar__spinner"
  })]) : (_vm.calendar.length > 0) ? _vm._l((_vm.calendar), function(event) {
    return _c('div', {
      key: event.id,
      staticClass: "board-calendar__event"
    }, [_c('CardCalendar', {
      attrs: {
        "item": event
      }
    })], 1)
  }) : _c('div', {
    staticClass: "board-calendar__empty"
  }, [_c('p', [_vm._v("Aucun rendez-vous " + _vm._s(_vm.isToday ? "aujourd'hui" : 'ce jour'))])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bcc87c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/BoardCalendar.vue
// module id = 1079
// module chunks = 0